import { GzEasmDnsRecordsWebComponent } from './component/GzEasmDnsRecordsWebComponent';

export { GzEasmDnsRecordsWebComponent };
